// extracted by mini-css-extract-plugin
module.exports = {"Title":"buyerInfo_Title__KsX8d","Frame":"buyerInfo_Frame__jDaBK"};